import { Grid } from "antd";

export interface Breakpoints {
  /** < 768px */
  isMobile: boolean;
  /** 768–1199px */
  isTablet: boolean;
  /** >= 1200px */
  isDesktop: boolean;
}

/** antd's Grid.useBreakpoint reports an empty screen map on first render;
 *  derive the tiers from the viewport width instead so the shell renders
 *  the correct layout immediately (no mobile-header flash on desktop). */
function fromViewportWidth(width: number): Breakpoints {
  return {
    isMobile: width < 768,
    isTablet: width >= 768 && width < 1200,
    isDesktop: width >= 1200,
  };
}

export function useBreakpoint(): Breakpoints {
  const screens = Grid.useBreakpoint();
  if (Object.keys(screens).length === 0 && typeof window !== "undefined") {
    return fromViewportWidth(window.innerWidth);
  }
  return {
    isMobile: !screens.md,
    isTablet: Boolean(screens.md) && !screens.xl,
    isDesktop: Boolean(screens.xl),
  };
}
